module.exports = "/cyber/_next/static/images/bestGamesSlide-20a0e3e5673e8c7e78dce7d9f98aac3c.jpg";